export default __webpack_public_path__ + "static/media/NIAS0090.34I-32793_-17904_0.76a0e3ff.jpg";